<template>
    <div class="modern-address-area">
        <div class="container">
            <div class="row align-items-center">
                <!-- Contact Information Section -->
                <div class="col-lg-6 col-md-12">
                    <div class="contact-info-wrapper">
                        <div class="section-header" data-aos="fade-right">
                            <h1 class="contact-title">Contact <span class="gradient-text">Us</span></h1>
                        </div>

                        <!-- Email Contact -->
                        <div class="contact-item" data-aos="fade-right" data-aos-delay="100">
                            <div class="contact-card">
                                <div class="icon-wrapper">
                                    <i class="ri-mail-fill"></i>
                                </div>
                                <div class="contact-details">
                                    <span class="contact-label">Email</span>
                                    <h4 class="contact-value">hi@meander.software</h4>
                                </div>
                            </div>
                        </div>

                        <!-- Phone Contact -->
                        <div class="contact-item" data-aos="fade-right" data-aos-delay="200">
                            <div class="contact-card">
                                <div class="icon-wrapper">
                                    <i class="ri-phone-fill"></i>
                                </div>
                                <div class="contact-details">
                                    <span class="contact-label">Phone Number</span>
                                    <h4 class="contact-value">(+91) 80-9054-9054</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Office Locations Section -->
                <div class="col-lg-6 col-md-12">
                    <div class="offices-grid">
                        <div class="row justify-content-center">
                            <!-- India Head Office -->
                            <div class="col-lg-6 col-sm-6 mb-4">
                                <div class="office-card" data-aos="fade-up" data-aos-delay="100">
                                    <div class="office-header">
                                        <div class="office-icon">
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                        <h3 class="office-title">India Head Office</h3>
                                    </div>
                                    <div class="office-address">
                                        <p>A-230, First Floor, Sector 8 Dwarka,</p>
                                        <p>Dwarka, New Delhi, Delhi 110077</p>
                                    </div>
                                </div>
                            </div>

                            <!-- USA Head Office -->
                            <div class="col-lg-6 col-sm-6 mb-4">
                                <div class="office-card featured" data-aos="fade-up" data-aos-delay="200">
                                    <div class="office-header">
                                        <div class="office-icon">
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                        <h3 class="office-title">USA Head Office</h3>
                                    </div>
                                    <div class="office-address">
                                        <p>98-61 Corona Ave. Queens,</p>
                                        <p>New York 11368</p>
                                    </div>
                                </div>
                            </div>

                            <!-- USA Satellite Suite -->
                            <div class="col-lg-6 col-sm-6 mb-4">
                                <div class="office-card featured" data-aos="fade-up" data-aos-delay="300">
                                    <div class="office-header">
                                        <div class="office-icon">
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                        <h3 class="office-title">USA Satellite Suite</h3>
                                    </div>
                                    <div class="office-address">
                                        <p>1032 E BRANDON BLVD</p>
                                        <p>#3432 BRANDON, FL 33511</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Development Center -->
                            <div class="col-lg-6 col-sm-6 mb-4">
                                <div class="office-card" data-aos="fade-up" data-aos-delay="400">
                                    <div class="office-header">
                                        <div class="office-icon">
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                        <h3 class="office-title">Development Center</h3>
                                    </div>
                                    <div class="office-address">
                                        <p>Tdi Business Centre, 11th Floor,</p>
                                        <p>Sector 118, Mohali, Punjab 160055.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Background Elements -->
        <div class="background-decorations">
            <div class="floating-shape shape-1"></div>
            <div class="floating-shape shape-2"></div>
            <div class="floating-shape shape-3"></div>
        </div>
    </div>
</template>

<style scoped>
/* Modern Address Area */
.modern-address-area {
    padding: 100px 0 75px;
    background: linear-gradient(279.99deg, #9F5FF1 -1.19%, #FF54B0 50.99%, #FF9F5A 100%); 
       position: relative;
    overflow: hidden;
    min-height: 80vh;
    display: flex;
    align-items: center;
}

/* Section Header */
.section-header {
    margin-bottom: 50px;
}

.contact-title {
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 30px;
    line-height: 1.1;
    text-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
}
/* 
.gradient-text {
    background: linear-gradient(135deg, #ff6b35 0%, #f7941d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
} */

/* Contact Information */
.contact-info-wrapper {
    padding-right: 30px;
}

.contact-item {
    margin-bottom: 25px;
}

.contact-card {
    display: flex;
    align-items: center;
    background: #fff5f5f5;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 25px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.contact-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.6s ease;
}

.contact-card:hover::before {
    left: 100%;
}

.contact-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 107, 53, 0.3);
}

.icon-wrapper {
    width: 60px;
    height: 60px;
   background: linear-gradient(221.69deg, #50E1E4 0%, #9A60EA 101.01%);
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
}

.icon-wrapper i {
    font-size: 24px;
    color: white;
}

.contact-details {
    flex: 1;
}

.contact-label {
    font-size: 14px;
    /* color: rgba(255, 255, 255, 0.7); */
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 1px;
    display: block;
    margin-bottom: 8px;
}

.contact-value {
    font-size: 1.4rem;
    font-weight: 700;
    /* color: #ffffff; */
    margin: 0;
    letter-spacing: 0.5px;
}

/* Office Cards */
.offices-grid {
    padding-left: 30px;
}

.office-card {
    background: #fff5f5f5;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 30px 25px;
    height: 100%;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.office-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(221.69deg, #50E1E4 0%, #9A60EA 101.01%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.office-card.featured::before {
    opacity: 1;
}

.office-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 107, 53, 0.3);
}

.office-card:hover::before {
    opacity: 1;
}

.office-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.office-icon {
    width: 50px;
    height: 50px;
 background: linear-gradient(221.69deg, #50E1E4 0%, #9A60EA 101.01%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    box-shadow: 0 6px 20px rgba(255, 107, 53, 0.3);
}

.office-icon i {
    font-size: 20px;
    color: white;
}

.office-title {
    font-size: 1.1rem;
    font-weight: 700;
    /* color: #ffffff; */
    margin: 0;
    line-height: 1.3;
}

.office-address {
    margin: 0;
}

.office-address p {
    /* color: #fff; */
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 5px;
    font-weight: 500;
}

.office-address p:last-child {
    margin-bottom: 0;
}

/* Background Decorations */
.background-decorations {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;
}

.floating-shape {
    position: absolute;
    border-radius: 50%;
    opacity: 0.1;
    animation: floatShape 8s ease-in-out infinite;
}

.shape-1 {
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, #ff6b35, #f7941d);
    top: 10%;
    right: 10%;
    animation-delay: 0s;
}

.shape-2 {
    width: 150px;
    height: 150px;
    background: linear-gradient(135deg, #60a5fa, #a78bfa);
    bottom: 20%;
    left: 5%;
    animation-delay: 3s;
}

.shape-3 {
    width: 100px;
    height: 100px;
    background: linear-gradient(135deg, #f472b6, #a855f7);
    top: 50%;
    left: 15%;
    animation-delay: 6s;
}

/* Animations */
@keyframes floatShape {
    0%, 100% {
        transform: translateY(0px) rotate(0deg);
    }
    50% {
        transform: translateY(-30px) rotate(180deg);
    }
}

/* Responsive Design */
@media (max-width: 991px) {
    .contact-info-wrapper {
        padding-right: 0;
        margin-bottom: 0px;
    }
    
    .offices-grid {
        padding-left: 0;
    }
    
   
}

@media (max-width: 767px) {
    .modern-address-area {
        padding: 40px 0 20px;
        min-height: auto;
    }

.section-header {
    margin-bottom: 20px;
}
    .contact-title {
        font-size: 30px;
        letter-spacing: 0;
        text-align: center;
    }
    
    .contact-card {
        padding: 20px;
        flex-direction: column;
        text-align: center;
    }
    
    .icon-wrapper {
        margin-right: 0;
        margin-bottom: 15px;
        width: 50px;
        height: 50px;
    }
    
    .contact-value {
        font-size: 1.2rem;
    }
    
    .office-card {
        padding: 25px 20px;
        margin-bottom: 20px;
    }
    
    .office-header {
        flex-direction: column;
        text-align: center;
    }
    
    .office-icon {
        margin-right: 0;
        margin-bottom: 15px;
        width: 45px;
        height: 45px;
    }
    
    .office-title {
        font-size: 1rem;
    }
    
    .office-address {
        text-align: center;
    }
    
    .floating-shape {
        display: none;
    }
}

@media (max-width: 575px) {

    
    .contact-value {
        font-size: 1.1rem;
    }
    
    .office-title {
        font-size: 0.95rem;
    }
    
    .office-address p {
        font-size: 0.9rem;
    }
}
</style>

<script>
export default {
    name: 'Address',
    methods: {
      openCalendly() {
     // eslint-disable-next-line no-undef
      Calendly.initPopupWidget({url:'https://calendly.com/connect-to-meander/30min'});
return false;
    }
  },
  mounted() {
    // Initialize AOS (Animate On Scroll) if available
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  }
}
</script>